import React, { Dispatch } from 'react'
import axios from 'ps-components/lib/apiClient';
import { Button, Code, Group, LoadingOverlay, ScrollArea, Table, Title } from '@mantine/core';
import { ReportInspectorState, ReportInspectorAction } from '../store';
import { useQuery } from 'react-query';
import { Detail } from '../Detail';

type Props = {
    query: string
    lastModified: string | Date
    state: ReportInspectorState
    dispatch: Dispatch<ReportInspectorAction>
}
const modifyKeys = (obj: any) => {
    const newObject: any = {};
    Object.keys(obj).forEach(k => {
        const pk = k.split('_')[1]
        newObject[pk] = obj[k]
    })
    return newObject
}
export const StoredQuery = ({ query, lastModified, state, dispatch }: Props) => {
    const executeQuery = async () => {
        const response = await axios.apiGet(`/api/marketpay-internal/report-inspector/storedQuery?reportPk=${state.selectedReportPk}`)
        if (!response.data.success || !response.data.query) throw new Error(response.data.message)
        const { query, fields } = response.data
        const queryData = query?.rows.map(modifyKeys)

        return { fields, queryData }
    }

    const { data, isLoading, isError } = useQuery(['reportQuery', { reportPk: state.selectedReportPk}], executeQuery, { enabled: state.showReportQuery, retry: false })
    const columns = data?.fields.map((f: any) => ({ label: f.default_title, pk: f.field_pk || f.formula_pk })) || []

    return (
        <>
            <Group mb={15}>
                <Button onClick={() => dispatch({ type: 'toggleReportQueryResults' })}>{state.showReportQuery ? 'View SQL' : 'Execute Query'}</Button>
                <Detail label='SQL Last Modified' value={lastModified as string} />
            </Group>
            {state.showReportQuery ?
                <>
                <LoadingOverlay visible={isLoading} />
                <ScrollArea>
                    <Table style={{ fontSize: 12, overflow: 'none' }} stickyHeader striped highlightOnHover withTableBorder>
                        <Table.Thead>
                            <Table.Tr>
                                {columns?.map((c: any) => (
                                    <Table.Th key={c.pk}>{c.label}</Table.Th>
                                ))}
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {data?.queryData?.map((r: any, i: number) => (
                                <Table.Tr key={r.report_pk}>
                                    {columns.map((c: any) => (
                                        <Table.Td key={c.pk}>
                                            {r[c.pk]}
                                        </Table.Td>
                                    ))}
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                    { isError && <Title ta='center' mt={30} order={2}>There was an error executing the stored query.</Title>}
                </ScrollArea>
                </>
                :
                <>
                { query && <Code style={{ fontSize: 12 }} block>{query}</Code> }
                </>
            }
        </>
    )
}